'use client';

import { useSocketContext } from '@/contexts/SocketProvider';

export function useSocket() {
  return useSocketContext();
}
